import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { BlockUIModule } from 'ng-block-ui';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'ngx-toastr';
import * as ɵngcc2 from 'ng-block-ui';
class DesktopService {
    constructor() { }
}
DesktopService.ɵfac = function DesktopService_Factory(t) { return new (t || DesktopService)(); };
DesktopService.ɵprov = i0.ɵɵdefineInjectable({ factory: function DesktopService_Factory() { return new DesktopService(); }, token: DesktopService, providedIn: "root" });
DesktopService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DesktopService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class DesktopComponent {
    constructor() { }
    ngOnInit() {
    }
}
DesktopComponent.ɵfac = function DesktopComponent_Factory(t) { return new (t || DesktopComponent)(); };
DesktopComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DesktopComponent, selectors: [["lib-desktop"]], decls: 2, vars: 0, template: function DesktopComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, " desktop works! ");
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
DesktopComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DesktopComponent, [{
        type: Component,
        args: [{
                selector: 'lib-desktop',
                template: `
    <p>
      desktop works!
    </p>
  `
            }]
    }], function () { return []; }, null); })();

class BlockUiTemplateComponent {
    constructor() { }
    ngOnInit() {
    }
}
BlockUiTemplateComponent.ɵfac = function BlockUiTemplateComponent_Factory(t) { return new (t || BlockUiTemplateComponent)(); };
BlockUiTemplateComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BlockUiTemplateComponent, selectors: [["lib-block-ui-template"]], decls: 2, vars: 0, consts: [["id", "block-ui-spinner", 1, "block-ui-spin-wrapper"], [1, "spinner"]], template: function BlockUiTemplateComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [".block-ui-spin-wrapper[_ngcontent-%COMP%]{width:100%;height:100%}.block-ui-spin-wrapper[_ngcontent-%COMP%]   .spinner[_ngcontent-%COMP%]{position:absolute;height:75px;width:75px;border:3px solid transparent;border-top-color:#a04668;top:calc(50% - 32.5px);left:calc(50% - 32.5px);border-radius:50%;animation:blockui-spinner-spin 2s linear infinite;z-index:9999999}.block-ui-spin-wrapper[_ngcontent-%COMP%]   .spinner[_ngcontent-%COMP%]:before, .block-ui-spin-wrapper[_ngcontent-%COMP%]   .spinner[_ngcontent-%COMP%]:after{content:\"\";position:absolute;border:3px solid transparent;border-radius:50%}.block-ui-spin-wrapper[_ngcontent-%COMP%]   .spinner[_ngcontent-%COMP%]:before{border-top-color:#254e70;top:-12px;left:-12px;right:-12px;bottom:-12px;animation:blockui-spinner-spin 3s linear infinite}.block-ui-spin-wrapper[_ngcontent-%COMP%]   .spinner[_ngcontent-%COMP%]:after{border-top-color:#7e7e7e;top:6px;left:6px;right:6px;bottom:6px;animation:blockui-spinner-spin 4s linear infinite}@keyframes blockui-spinner-spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}"] });
BlockUiTemplateComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BlockUiTemplateComponent, [{
        type: Component,
        args: [{
                selector: 'lib-block-ui-template',
                template: `<div class="block-ui-spin-wrapper" id="block-ui-spinner"><div class="spinner"></div></div>`,
                styles: [".block-ui-spin-wrapper{width:100%;height:100%}.block-ui-spin-wrapper .spinner{position:absolute;height:75px;width:75px;border:3px solid transparent;border-top-color:#a04668;top:calc(50% - 32.5px);left:calc(50% - 32.5px);border-radius:50%;animation:blockui-spinner-spin 2s linear infinite;z-index:9999999}.block-ui-spin-wrapper .spinner:before,.block-ui-spin-wrapper .spinner:after{content:\"\";position:absolute;border:3px solid transparent;border-radius:50%}.block-ui-spin-wrapper .spinner:before{border-top-color:#254e70;top:-12px;left:-12px;right:-12px;bottom:-12px;animation:blockui-spinner-spin 3s linear infinite}.block-ui-spin-wrapper .spinner:after{border-top-color:#7e7e7e;top:6px;left:6px;right:6px;bottom:6px;animation:blockui-spinner-spin 4s linear infinite}@keyframes blockui-spinner-spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}\n"]
            }]
    }], function () { return []; }, null); })();

class DesktopModule {
}
DesktopModule.ɵfac = function DesktopModule_Factory(t) { return new (t || DesktopModule)(); };
DesktopModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DesktopModule });
DesktopModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            RouterModule,
            BrowserAnimationsModule,
            ToastrModule.forRoot({ closeButton: true }),
            BlockUIModule.forRoot({
                template: BlockUiTemplateComponent
            })
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DesktopModule, [{
        type: NgModule,
        args: [{
                declarations: [DesktopComponent, BlockUiTemplateComponent],
                imports: [
                    RouterModule,
                    BrowserAnimationsModule,
                    ToastrModule.forRoot({ closeButton: true }),
                    BlockUIModule.forRoot({
                        template: BlockUiTemplateComponent
                    })
                ],
                exports: [DesktopComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DesktopModule, { declarations: function () { return [DesktopComponent, BlockUiTemplateComponent]; }, imports: function () { return [RouterModule,
        BrowserAnimationsModule, ɵngcc1.ToastrModule, ɵngcc2.BlockUIModule]; }, exports: function () { return [DesktopComponent]; } }); })();

/*
 * Public API Surface of desktop
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DesktopComponent, DesktopModule, DesktopService, BlockUiTemplateComponent as ɵa };

